// Cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  const cleanUp = () => {
    if (window.innerWidth >= 900) {
      // Pantallas anchas: eliminar todos los .mr1
      document.querySelectorAll('.mr1').forEach(el => el.remove());
    } else {
      // Pantallas estrechas: eliminar todos los .mr2
      document.querySelectorAll('.mr2').forEach(el => el.remove());
    }
  };

  // Ejecutamos una vez al inicio
  
  cleanUp();

  // Y también cada vez que cambie el tamaño de ventana
  window.addEventListener('resize', () => {
    cleanUp();
  });
});


function initVariantCarousels() {
  // ———————————————————————————————
  // 1) Carrusel de variantes (Color/Sabor) con Talla
  // ———————————————————————————————
  const containers = document.querySelectorAll(
    '.variant-carousel-container, .quick-shop-modal .variant-carousel-container'
  );

  containers.forEach(container => {
    // Evitar doble inicialización
    if (container.dataset.initialized) return;
    container.dataset.initialized = true;

    const row            = container.querySelector('.options-row');
    const prev           = container.querySelector('.carousel-arrow-left');
    const next           = container.querySelector('.carousel-arrow-right');
    const card           = container.closest('.quick-shop-modal')
                              ? container.closest('.quick-shop-modal__body')
                              : container.closest('.grid-product__content');
    const mainImg        = card.querySelector('.main-image');
    const addBtn         = card.querySelector('.add-to-cart-btn');
    const grid           = card.closest('.grid-product');
    const variants       = JSON.parse(grid.dataset.variants);
    const labelCurrent   = card.querySelector('.variant-label-current');

    let currentId        = addBtn.dataset.variantId;
    let selectedSize     = null;
    let selectedOption2  = null;
    let lastClickedOption2 = null; // almacena la opción que clicas

    // Selector de talla
    const sizeSelect = grid.querySelector('select.size-select');
    if (sizeSelect) {
      selectedSize = sizeSelect.value;
      sizeSelect.addEventListener('change', e => {
        selectedSize = e.target.value;
        recalcVariant();
      });
    }

    // Flechas del carrusel
    prev.addEventListener('click', e => {
      e.stopPropagation();
      row.scrollBy({ left: -100, behavior: 'smooth' });
    });
    next.addEventListener('click', e => {
      e.stopPropagation();
      row.scrollBy({ left: 100, behavior: 'smooth' });
    });

    // Inicializar si ya había .active
    const inicialActive = row.querySelector('.variant-option.active');
    if (inicialActive) {
      selectedOption2    = inicialActive.dataset.optionValue || inicialActive.querySelector('img').alt;
      lastClickedOption2 = selectedOption2;
      if (labelCurrent) labelCurrent.textContent = selectedOption2;
      recalcVariant();
    }

    // Miniaturas color/sabor
    row.querySelectorAll('.variant-option').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        selectedOption2     = btn.dataset.optionValue || btn.querySelector('img').alt;
        lastClickedOption2  = selectedOption2;

        row.querySelectorAll('.variant-option').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        if (labelCurrent) labelCurrent.textContent = selectedOption2;
        mainImg.src = btn.dataset.image;
        recalcVariant();
      });
    });

    function recalcVariant() {
      const match = variants.find(v =>
        (selectedSize    ? v.option1 === selectedSize    : true) &&
        (selectedOption2 ? v.option2 === selectedOption2 : true)
      );
      if (match) {
        currentId = match.id;
        addBtn.dataset.variantId = currentId;
        addBtn.disabled = !match.available;
        if (labelCurrent) labelCurrent.textContent = match.option2;
      }
    }

    // Helper: reintenta recalcVariant hasta alinear con la opción clicada
    async function ensureCorrectVariant(lastOption, maxTries = 20, delay = 50) {
      let tries = 0;
      while (tries < maxTries) {
        recalcVariant();
        const match = variants.find(v =>
          (selectedSize    ? v.option1 === selectedSize    : true) &&
          (lastOption      ? v.option2 === lastOption      : true)
        );
        if (match && match.id === currentId) return true;
        await new Promise(r => setTimeout(r, delay));
        tries++;
      }
      return false;
    }

    // Añadir al carrito (con carrusel)
    addBtn.addEventListener('click', async () => {
      if (!lastClickedOption2) {
       
        return;
      }

      // Reintentar hasta validar
      const ok = await ensureCorrectVariant(lastClickedOption2);
      if (!ok) {
       
        return;
      }

      // Ya seguro: enviamos la petición
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type':'application/json' },
          body: JSON.stringify({ id: currentId, quantity: 1 })
        });
       sessionStorage.setItem('openCartDrawer','true');
        setTimeout(() => location.reload(), 100);
      } catch {
        addBtn.textContent = 'Error';
      }
    });
  });

  // ———————————————————————————————
  // A) Productos con SOLO TALLA
  // ———————————————————————————————
  document.querySelectorAll('.variant-size-select .size-select').forEach(select => {
    if (select.dataset.initialized) return;
    select.dataset.initialized = true;

    const grid     = select.closest('.grid-product');
    const addBtn   = grid.querySelector('.add-to-cart-btn');
    const variants = JSON.parse(grid.dataset.variants);

    select.addEventListener('change', e => {
      const size  = e.target.value;
      const match = variants.find(v => v.option1 === size);
      if (match) {
        addBtn.dataset.variantId = match.id;
        addBtn.disabled = !match.available;
      }
    });
  });

  // ———————————————————————————————
  // B) Productos con SOLO COLOR/SABOR
  // ———————————————————————————————
  document.querySelectorAll('.variant-carousel-container').forEach(container => {
    if (container.closest('.grid-product').querySelector('.variant-size-select')) return;
    if (container.dataset.simpleInitialized) return;
    container.dataset.simpleInitialized = true;

    const grid   = container.closest('.grid-product');
    const addBtn = grid.querySelector('.add-to-cart-btn');

    container.querySelectorAll('.variant-option').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.sampleVariantId;
        addBtn.dataset.variantId = id;
        addBtn.disabled = false;
      });
    });
  });

  // ———————————————————————————————
  // 2) Listener global para productos sin variantes
  // ———————————————————————————————
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    if (btn.closest('.variant-carousel-container')) return;
    if (btn.dataset.globalListener) return;
    btn.dataset.globalListener = true;

    btn.addEventListener('click', async e => {
      const button    = e.currentTarget;
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      button.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        sessionStorage.setItem('openCartDrawer','true');
        setTimeout(() => location.reload(), 100);
      } catch {
        button.textContent = 'Error';
        button.disabled   = false;
      }
    });
  });

if (sessionStorage.getItem('openCartDrawer') === 'true') {
  sessionStorage.removeItem('openCartDrawer');
  setTimeout(() => {
    document.querySelector('.js-drawer-open-cart')?.click();
  }, 50);
}
 
}


window.addEventListener('DOMContentLoaded', initVariantCarousels);